import {create} from 'zustand'

import type {MediaPlayer} from '@vidstack/react/types/vidstack'

interface PlayersState {
  players: Record<string, MediaPlayer>
  addPlayer: (id: string, player: MediaPlayer) => void
  removePlayer: (id: string) => void
  pauseOtherPlayers: (currentId: string) => void
  pauseAllPlayers: () => void
}

export const usePlayersStore = create<PlayersState>()(
  (set, get) => ({
    players: {},
    addPlayer: (id, player) =>
      set(({players}) => ({players: {...players, [id]: player}})),
    removePlayer: (id) =>
      set(({players: {[id]: player, ...restPlayers}}) => ({players: restPlayers})),
    pauseOtherPlayers: (currentId) =>
      Object.entries(get().players).forEach(([id, p]) => id !== currentId ? p.pause() : null),
    pauseAllPlayers: () => Object.entries(get().players).forEach(([_id, p]) => p.pause()),
  }),
)
